<template>
  <div id="app" class="col-md-8 col-xs-12 col-sm-12 col-12 layout-register">
    <template v-if="step">
      <p v-if="!error" class="small-text progress-bar-text">
        Paso {{ step }} de 10
      </p>
      <p v-else class="small-text progress-bar-text">Proceso rechazado</p>
      <progress :class="error ? 'progress-error' : ''" max="10" :value="step">
      </progress>
    </template>
    <div class="row">
      <div class="col-xs-12 col-12" :class="classesTitle">
        <h1 class="big-title text-left-desktop">
          <slot name="title-step">
            {{ titleStep }}
          </slot>
        </h1>
      </div>
    </div>
    <p class="description-page md-text-center" v-if="descriptionPage">
      <slot name="description-page"></slot>
    </p>
    <div class="container-fluid p0">
      <slot></slot>
      <div class="row" v-if="nextBtnText">
        <div class="col-md-7 col-xs-12 col-sm-12 col-12">
          <a-btn class="next-step-button" primary>
            {{ nextBtnText }}
          </a-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ABtn from '@/components/ui/ABtn';

export default {
  name: 'layout-register',
  props: {
    step: {
      type: Number,
    },
    error: {
      type: Boolean,
      default: false,
    },
    titleStep: String,
    nextBtnText: String,
    mdTitle: {
      type: [String, Number],
      default: 8,
    },
    classDescription: [String, Array],
  },
  components: {
    ABtn,
  },
  computed: {
    descriptionPage() {
      return !!this.$slots['description-page'];
    },
    classesTitle() {
      return [`col-md-${this.mdTitle}`];
    },
  },
};
</script>
